import React from "react"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"
import Layout from "../components/Layout"
import SEO from "../components/SEO"
import Hero from "../components/Hero"
import Services from "../components/Services"
import ResumeChat from "../components/ResumeChat"
import Jobs from "../components/Jobs"
import Projects from "../components/Projects"
import Blogs from "../components/Blogs"
import Testimonials from "../components/Testimonials"
import Footer from "../components/Footer"

export default ({data}) => {
  const {
    allProject:{nodes:projects},
    allBlogsJson:{nodes:blogs},
  } = data

  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Nishant Tiwari",
    url: "https://nishanttiwari.com",
    jobTitle: "Agentic AI Engineer, Solutions Architect",
    description:
      "Agentic AI engineer, solutions architect and DevOps engineer with 15+ years building autonomous AI agents and production cloud platforms on AWS, GCP and Kubernetes.",
    knowsAbout: [
      "Agentic AI",
      "AI agents",
      "LLM fine-tuning",
      "Model Context Protocol",
      "AWS",
      "Kubernetes",
      "DevOps",
      "Cloud architecture",
      "Solutions architecture",
    ],
    sameAs: [
      "https://www.linkedin.com/in/nishanttiwari",
      "https://github.com/nt1412",
      "https://twitter.com/nishanttiwari",
      "https://www.youtube.com/@nt1412",
    ],
    address: {
      "@type": "PostalAddress",
      addressLocality: "Mumbai",
      addressRegion: "Maharashtra",
      addressCountry: "IN",
    },
  }

  return (<Layout>
    <SEO title="Nishant Tiwari" description="Agentic AI Engineer, Solutions Architect & DevOps Engineer with 15+ years experience. Builds autonomous agents (PDCA/ReAct-style, tool-use) and LoRA fine-tuning pipelines. 5x AWS (lapsed) + CKAD, PMP active — skills current. Top Rated Plus on Upwork." />
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(personSchema)}</script>
    </Helmet>
    <Hero/>
    <Services/>
    <ResumeChat/>
    <Jobs/>
    <Projects projects={projects} title="featured projects" showLink/>
    <Testimonials/>
    <Blogs blogs={blogs} title="Latest Articles" showLink/>

  </Layout>)

}
export const query = graphql`
  {
    allProject(filter: {featured: {eq: true}}) {
      nodes {
        id
        slug
        description
        title
        links {
          label
          url
        }
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
        stack_icons {
          name
          icon {
            childImageSharp {
              fixed(height: 20) {
                ...GatsbyImageSharpFixed_withWebp_tracedSVG
              }
            }
          }
        }
      }
    }
    allBlogsJson(limit: 3) {
      nodes {
        slug
        content
        desc
        date
        id
        title
        category
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    }


  }`
